module.exports = __webpack_public_path__ + "media/images/logo-redcare-95517d4570e79bbd942719bcdc7e17d1.png";